// store/webinarSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = `https://api-workshop.firststepoverseas.com/webinars/1`;

// Async thunk to fetch webinars
export const fetchWebinars = createAsyncThunk(
  "webinars/fetchWebinars",
  async (_, { rejectWithValue }) => {
    try {
      const access = localStorage.getItem("access"); // token stored from auth
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `JWT ${access}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { detail: "Failed to fetch webinars" }
      );
    }
  }
);

const webinarSlice = createSlice({
  name: "webinars",
  initialState: {
    items: null,
    count: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebinars.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWebinars.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        // state.items = action.payload.results || [];
        // state.count = action.payload.count || 0;
      })
      .addCase(fetchWebinars.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.detail || "Unable to load webinars";
      });
  },
});

export default webinarSlice.reducer;
